<template>
  <div>
    <Modal v-model="show" title="新增费用支出" :width="1000" :mask-closable="false" :footer-hide="true">
      <div v-show="step == 1" class="step step1">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
          <FormItem label="转账出款学校：" prop="schoolAcctNo">
            <Select
              v-model="formValidate.schoolAcctNo"
              placeholder="请选择学校"
              style="width: 300px"
              filterable
              clearable
              :remote-method="handleAccRemoteMethod"
              :loading="accLoading"
              :disabled="portOrg == 2"
              @on-change="onAcctChange"
              @on-clear="onSchAcctClear"
            >
              <Option v-for="item in schList" :key="item.acctNo" :value="item.acctNo">{{ item.acctName }}</Option>
            </Select>
          </FormItem>
          <FormItem label="转账业务名称：" prop="busiName">
            <Input v-model.trim="formValidate.busiName" placeholder="请输入转账业务名称" style="width: 300px"></Input>
          </FormItem>
          <FormItem label="收款姓名：" prop="inObjName">
            <!-- <Input
              v-model="formValidate.inObjName"
              placeholder="支持搜索历史收款人"
              style="width: 300px"
            /> -->
            <AutoComplete
              v-model="autoCompleteIn"
              placeholder="支持搜索历史收款人"
              clearable
              style="width: 300px"
              @on-search="handleAutoComSearch"
              @on-select="onAutoComSelect"
              @on-focus="onAutoComFocus"
              @on-blur="onAutoComBlur"
              @on-change="onAutoComChange"
              @on-clear="onAutoComClear"
            >
              <Option v-for="(item, index) in inAcctHyList" :key="index" :value="item.id">{{ item.acctName }}({{
                item.acctNo }})</Option>
            </AutoComplete>
            <!-- <div class="in-accthy-list" style="width: 300px">
              <h2>历史汇款记录</h2>
              <div class="list-main">
                <ul>
                  <li
                    v-for="(item, index) in inAcctHyList"
                    :key="index"
                    @click="handleInAcctHy(item)"
                  >
                    {{ item.acctName }}({{ item.acctNo }})
                  </li>
                </ul>
              </div>
            </div> -->
          </FormItem>
          <FormItem label="收款子账户：" prop="inAcctNo">
            <Input
              v-model="formValidate.inAcctNo"
              placeholder="请输入收款子账户"
              style="width: 300px"
              :disabled="inNameDisabled"
            ></Input>
          </FormItem>
          <FormItem label="汇款金额：" prop="amount">
            <InputNumber v-model="formValidate.amount" :min="0" placeholder="请输入汇款金额" style="width: 300px"></InputNumber>
          </FormItem>
          <FormItem label="支出类型：" prop="outFeeType">
            <Select v-model="formValidate.outFeeType" placeholder="请选择支出类型" style="width: 300px">
              <Option v-for="item in typeList" :key="item.value" :value="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="转出备注：" prop="remark">
            <Input v-model="formValidate.remark" type="textarea" :rows="4" placeholder="转出备注" style="width: 300px"></Input>
          </FormItem>
          <FormItem label="付款证明函：" prop="fileIds">
            <PayImage ref="payImageRef" @on-change="onChangePayImage"></PayImage>
          </FormItem>
          <FormItem label="学期" prop="yearTermCode">
            <CascaderYearTerms
              ref="cascaderYearTermsRef"
              :clearable="false"
              :placeholder="`请选择学期`"
              style="width:250px"
              @on-change="onCascaderChange"
            >
            </CascaderYearTerms>
          </FormItem>
          <FormItem label="出款账户：">
            <div v-show="formValidate.schoolAcctNo">
              {{ outAccountInfo.acctName }}({{ outAccountInfo.acctNo }})
              <span style="margin-right:10px">可用余额：{{ availAmtShow }} 元</span>
              <span>冻结金额：{{ lockAmtShow }} 元</span>
              <Icon size="18" class="cursor-pointer" type="md-refresh-circle" @click="handleRefresh"></Icon>
            </div>
          </FormItem>
        </Form>
      </div>
      <div v-show="step == 2" class="step step2">
        <Form :label-width="150">
          <FormItem label="收款姓名：">{{ formValidate.inObjName }} </FormItem>
          <FormItem label="汇款金额："><span style="color: red">¥{{ formValidate.amount }}</span>
          </FormItem>
          <p class="text">上述信息确认无误后，请进行手机验证码获取。</p>
          <FormItem label="手机号码：">
            {{ outAccountInfo.phoneNo | fliterPhone }}</FormItem>
          <FormItem label="验证码：">
            <div class="input-main">
              <Input v-model="formValidate.msgCode" placeholder="请输入短信验证码" style="width: 300px"></Input>
              <p class="msg-text" @click="handleSend">{{ msgText }}</p>
            </div>
            <p class="msg-error">{{ codeErrorStr }}</p>
          </FormItem>
        </Form>
      </div>
      <div class="btn-wrap">
        <div v-show="step == 1">
          <Button
            type="primary"
            style="width: 120px; margin-bottom: 15px"
            @click="handleNext('formValidate')"
          >确认转出</Button>
          <p style="color: #666">转出金额预计实时1-3工作日到达对方账户</p>
        </div>
        <div v-show="step == 2">
          <Button @click="handleToBack">返回修改</Button>
          <Button type="primary" style="margin-left: 20px" @click="handleSubmit">确认转出</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import financeCenterApi from '@/request/financeCenter/index.js';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms';
import PayImage from './PayImage.vue';
import { fliterPhone, apiPostMoneyYuanChangeFen, moneyFenChangeYuan, minus } from '@/utils/utils.js';
// import BigNumber from 'bignumber.js';

export default {
  components: {
    PayImage, CascaderYearTerms
  },
  filters: {
    fliterPhone(phone) {
      if (phone) {
        return fliterPhone(phone);
      } else {
        return '--';
      }
    }
  },
  data() {
    const inAcctNoCheck = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入收款子账户'));
      } else if (value.length != 16 || value.indexOf('56') != 0) {
        callback(new Error('提示：收款子账户为平安银行见证宝子账户，以56开头的16位数字，非收款方的实体银行卡账户！'));
      } else {
        callback();
      }
    };
    const amountCheck = (rule, value, callback) => {
      let length = 0;
      const arr = (value + '').split('.');
      if (arr.length === 2) {
        length = arr[1].length;
      }
      if (!value) {
        callback(new Error('请输入汇款金额'));
      } else if (length > 2) {
        callback(new Error('请输入最多两位小数的金额'));
      } else if (+apiPostMoneyYuanChangeFen(value) > +this.availAmtTrue) {
        callback(new Error('汇款金额不得大于当前可用余额'));
      } else {
        callback();
      }
    };
    return {
      show: false,
      step: 1,
      formValidate: {
        schoolAcctNo: '',
        schoolName: '',
        busiName: '',
        outFeeType: '2',
        inAcctNo: '',
        inObjName: '',
        amount: null,
        remark: '',
        msgCode: '',
        fileIds: [],
        yearTermCode: []
      },
      codeErrorStr: '',
      msgText: '获取验证码',
      inNameDisabled: false,
      ruleValidate: {
        schoolAcctNo: [
          { required: true, message: '请选择转帐出款学校', trigger: 'change' }
        ],
        busiName: [
          { required: true, message: '请输入转账业务名称', trigger: 'blur' }
        ],
        inObjName: [
          { required: true, message: '请输入收款姓名', trigger: 'blur' }
        ],
        inAcctNo: [
          { required: true, validator: inAcctNoCheck, trigger: 'blur' }
        ],
        amount: [
          { required: true, validator: amountCheck, trigger: 'blur' }
        ],
        yearTermCode: [
          { type: 'array', required: true, message: '请选择学年学期', trigger: 'change' }
        ],
        outFeeType: [
          { required: true, message: '请选择支出类型', trigger: 'change' }
        ],
        remark: [
          { required: true, message: '请输入转出备注', trigger: 'blur' }
        ],
        fileIds: [
          { type: 'array', required: true, message: '请上传付款证明函', trigger: 'change' }
        ]

      },
      typeList: [{
        value: '2',
        label: '其他支出'
      }],
      schList: [], // 转账出款学校
      outAccountInfo: {
        acctName: '',
        acctNo: '',
        phoneNo: '',
        availAmt: 0, // 可用余额（包含锁定部分） 分
        lockAmt: 0// 锁定金额 分
      },
      autoCompleteIn: '', //
      inAcctHyList: [], // 历史转入方
      seqNo: '', // 发送短信后返回的业务码
      portOrg: localStorage.getItem('portOrg'),
      accLoading: false

    };
  },
  computed: {
    // 真正的可用余额，要展示在页面上的 真正的可用余额=availAmt - lockAmt
    availAmtTrue() {
      return minus(this.outAccountInfo.availAmt, this.outAccountInfo.lockAmt);
    },
    availAmtShow() {
      return moneyFenChangeYuan(this.availAmtTrue);
      // return moneyFenChangeYuan(this.outAccountInfo.availAmt);
    },
    // 冻结金额，要展示在页面上的
    lockAmtShow() {
      return moneyFenChangeYuan(this.outAccountInfo.lockAmt);
    }
  },
  watch: {
    autoCompleteIn(newVal, oldVal) {
      if (newVal.indexOf('430PAY') > -1) {
        this.$nextTick(() => {
          const valueArr = newVal.split('430PAY');
          this.autoCompleteIn = valueArr[0];
          this.formValidate.inAcctNo = valueArr[1];
          this.formValidate.inObjName = valueArr[0];
          this.inNameDisabled = true;
          this.$refs.formValidate.validateField('inObjName');
          this.$refs.formValidate.validateField('inAcctNo');
        });
      } else {
        this.formValidate.inObjName = newVal;
      }
    },
    'formValidate.schoolName': function(newVal, oldVal) {

    }
  },
  created() {

  },
  mounted() {
    // this.handleShow()
  },
  methods: {
    async onCascaderChange(v) {
      this.formValidate.yearTermCode = v;
      this.$refs.formValidate.validateField('yearTermCode');
    },
    handleShow() {
      this.show = true;
      this.$refs.payImageRef.clear();
      this.initData();

      this.getOutAccountPage('');
    },
    initData() {
      this.handleReset('formValidate');
      for (const k in this.formValidate) {
        this.formValidate[k] = '';
        if (['amount'].includes(k)) {
          this.formValidate[k] = null;
        }
      }
      for (const k in this.outAccountInfo) {
        this.outAccountInfo[k] = '';
        if (['availAmt', 'lockAmt'].includes(k)) {
          this.outAccountInfo[k] = 0;
        }
      }
      this.$nextTick(() => {
        const yearAr = (this.$refs.cascaderYearTermsRef && this.$refs.cascaderYearTermsRef.getResult()) || [];
        if (yearAr.length > 0) {
          this.onCascaderChange(yearAr);
        }
      });
      this.autoCompleteIn = '';
      this.step = 1;
      this.inNameDisabled = false;
      this.getInAcctHistory('');
    },
    // 付款证明函 上传图片组件改变回调
    onChangePayImage(arr) {
      this.formValidate.fileIds = arr;
      this.$refs.formValidate.validateField('fileIds');

      // this.validateField
    },
    handleHide() {
      this.show = false;
    },
    handleToBack() {
      this.step = 1;
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    async handleNext(name) {
      //

      this.$refs[name].validate((valid) => {
        if (valid) {
          this.step = 2;
        } else {

        }
      });
    },
    handleAutoComSearch(query) {
      if (query.length < 20) {
        this.getInAcctHistory(query);
      }
    },
    //
    onAutoComSelect(value) {

    },
    onAutoComFocus() {
      this.inNameDisabled = false;
    },
    onAutoComChange(value) {
      if (!value) {
        this.getInAcctHistory('');
      }
    },
    onAutoComClear() {

    },
    onAutoComBlur() {
      this.$refs.formValidate.validateField('inObjName');
    },
    //
    handleInAcctHy(row) {
      this.formValidate.inObjName = row.acctName;
      this.formValidate.inAcctNo = row.acctNo;
    },
    handleRefresh() {
      this.getOutAccountInfo(this.formValidate.schoolAcctNo);
    },
    handleSubmit() {
      if (!this.formValidate.msgCode) {
        this.$Message.warning('请输入短信验证码');
        return null;
      }
      this.setExpenseTrans();
    },
    // 查询历史转入方（
    async getInAcctHistory(acctName) {
      if (!this.formValidate.schoolAcctNo) {
        return null;
      }
      this.accLoading = true;
      const res = await financeCenterApi.getInAcctHistoryApi({
        acctName: acctName,
        outAcctNo: this.formValidate.schoolAcctNo,
        pageSize: 30,
        pageNum: 1
      });
      this.accLoading = false;
      if (res.status == 200) {
        res.message.list.forEach(item => {
          // 430PAY 做链接
          item.id = `${item.acctName}430PAY${item.acctNo}`;
        });
        this.inAcctHyList = res.message.list;
      }
    },
    // 收款姓名控件初始化
    initAutoCom() {
      this.inNameDisabled = false;
      this.autoCompleteIn = '';
      this.inAcctHyList = [];
      this.formValidate.inAcctNo = '';
      this.formValidate.inObjName = '';
    },
    // 查询转出方选择变更
    onAcctChange(acctNo) {
      this.formValidate.schoolName = this.getInAcctName(acctNo);
      this.initAutoCom();
      acctNo && this.getInAcctHistory('');
      acctNo && this.getOutAccountInfo(acctNo);
    },
    handleAccRemoteMethod(query) {
      console.log(query);
      this.getOutAccountPage(query);
    },
    onSchAcctClear() {
      this.formValidate.schoolName = '';
      this.inAcctHyList = [];
      this.formValidate.inAcctNo = '';
      this.formValidate.inObjName = '';
      this.getOutAccountPage('');
    },
    // 获取转出方名称
    getInAcctName(acctNo) {
      const key = this.schList.findIndex(item => {
        return item.acctNo == acctNo;
      });
      return key != -1 ? this.schList[key]['acctName'] : '';
    },
    // 查询转出方 列表
    async getOutAccountPage(acctName) {
      const res = await financeCenterApi.getOutAccountPageApi({
        acctName: acctName,
        pageNum: 1,
        pageSize: 30
      });
      if (res.status == 200) {
        this.schList = res.message.list;
        if (this.portOrg == 2 && this.schList.length > 0) {
          this.formValidate.schoolAcctNo = this.schList[0]['acctNo'];
          this.formValidate.schoolName = this.schList[0]['acctName'];
          this.getOutAccountInfo(this.schList[0]['acctNo']);
        }
      }
    },
    // 发送短信验证码
    async handleSend() {
      if (this.msgText != '获取验证码') {
        return null;
      }
      this.codeErrorStr = '';
      this.$Spin.show();
      const res = await financeCenterApi.sendTransExpenseMsgApi({
        phone: this.outAccountInfo.phoneNo,
        // amount: this.formValidate.amount * 100,
        amount: apiPostMoneyYuanChangeFen(this.formValidate.amount), // js计算有精度丢失问题，所以用这个BigNumber进行数据处理
        busiName: this.formValidate.busiName,
        inAcctNo: this.formValidate.inAcctNo,
        outAcctNo: this.formValidate.schoolAcctNo,
        actCode: 'TransExpense'
      });
      this.$Spin.hide();
      if (res.status == 200) {
        this.$Message.success('短信已发送成功，请注意查收');
        this.seqNo = res.message;
        let second = 60;
        this.msgText = `${second}s后获取`;
        this.timer = setInterval(() => {
          if (second == 0) {
            clearInterval(this.timer);
            this.msgText = '获取验证码';
            return false;
          }
          second--;
          this.msgText = `${second}s后获取`;
        }, 1000);
      } else {
        this.codeErrorStr = res.error;
      }
    },
    // 查询转出方具体信息
    async getOutAccountInfo(acctNo) {
      const res = await financeCenterApi.getOutAccountInfoApi({
        acctNo
      });
      if (res.status == 200) {
        this.outAccountInfo = res.message;
      }
    },
    // 新增费用支出
    async setExpenseTrans() {
      const fileIds = await this.$refs.payImageRef.getFileId();
      const data = { ...this.formValidate, seqNo: this.seqNo, phone: this.outAccountInfo.phoneNo, actCode: 'TransExpense' };
      data.inObjName = data.inObjName.replace(/^\s*|\s*$/g, '');
      // data.amount = data.amount * 100;
      data.amount = apiPostMoneyYuanChangeFen(data.amount);
      data.attachPhotos = fileIds.join(',');
      data.yearCode = this.formValidate.yearTermCode[0];
      data.termCode = this.formValidate.yearTermCode[1];
      delete data.fileIds;
      this.$Spin.show();
      const res = await financeCenterApi.setExpenseTransApi(data);
      this.$Spin.hide();
      if (res.status == 200) {
        this.$Modal.success({
          title: '提示',
          content: `<h1>操作成功!</h1><p>转出金额预计实时1-3工作日到达对账账户，请留意钱包变动通知！</p>`
        });

        this.handleHide();
        this.$emit('on-success');
      }
    }
  }
};
</script>
<style lang="scss" ></style>
<style lang="scss" scoped>
.step {
  padding: 0 50px;

  /deep/ .ivu-auto-complete {
    overflow-y: scroll;
    max-height: 300px;
  }

  .text {
    background-color: #dcdfe6;
    padding: 4px 0 4px 70px;
    margin-bottom: 8px;
  }
}

.btn-wrap {
  text-align: center;
}

.in-accthy-list {
  width: 300px;
  border: 1px solid #dcdee2;
  padding: 4px;
  border-radius: 4px;

  .list-main {
    height: 150px;
    overflow-y: scroll;

    ul {
      li {
        cursor: pointer;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap; // 默认不换行；
      }
    }
  }
}

.input-main {
  position: relative;
  width: 300px;

  .msg-text {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: #6149f1;
    cursor: pointer;
  }
}

.msg-error {
  color: red;
}
</style>
